module.exports = __webpack_public_path__ + "static/media/sprite2.e4953aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/sprite2.png
// module id = 495
// module chunks = 0